
const backend_url = {
    prod: "https://pospartners.myginne.com/V5",
    stag: "https://dev.myginne.com/V4",
    local: "",
  };
  export var BASE_URL = backend_url.prod;
  